import { HttpMethod, Command } from "~/extensions/api";
export class FindShomeiList extends Command {
    constructor() {
        super(HttpMethod.Get, "shomei/list");
    }
}
